import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ButtonSizes } from '@app/app/shared/styleguide/components/buttons/default/button.component';
import { IconComponent } from '@app/app/shared/styleguide/components/icon/icon.component';
import { LucideIconInput } from '@lucide/angular';

@Component({
  selector: 'ptl-sidebar-item-base',
  templateUrl: './sidebar-item-base.component.html',
  styleUrls: ['./sidebar-item-base.component.scss'],
  standalone: true,
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarItemBaseComponent {
  text = input<string>();
  count = input<number>();
  icon = input<LucideIconInput>();
  size = input<ButtonSizes>('l');
  isActive = input(false);
}
